export default function Privacy() {
  return (
    <div className="py-28 px-6 md:px-10" data-testid="privacy-page">
      <div className="max-w-3xl mx-auto">
        <div className="text-[11px] uppercase tracking-[0.25em] text-gold font-semibold">Legal</div>
        <h1 className="display text-5xl md:text-6xl mt-3 text-ink">Privacy Policy</h1>
        <p className="mt-4 text-xs text-ink/50">Effective date: February 2026</p>

        <div className="mt-10 space-y-6 text-ink/75 leading-relaxed font-light">
          <p>
            Flint Islamic Center (<strong>"FIC"</strong>, <strong>"we"</strong>, <strong>"us"</strong>, <strong>"our"</strong>) is a
            religious non-profit organization recognized under Section 501(c)(3) of the U.S. Internal Revenue Code.
            We respect the privacy of every visitor to flintislamiccenter.com ("Website") and every member of our
            community. This policy explains what information we collect, how we use it, and the choices you have.
          </p>

          <h2 className="font-serif text-2xl text-ink pt-4">1. Information We Collect</h2>
          <p>
            <strong>Newsletter signups.</strong> If you subscribe, we collect your first name and email address so we
            can send you FIC announcements, event reminders, and Ramadan communications. You can unsubscribe at any time.
          </p>
          <p>
            <strong>Contact form submissions.</strong> Name, email, phone (optional), and your message — used only to
            respond to your inquiry.
          </p>
          <p>
            <strong>Donations.</strong> Donations are processed by <em>Stripe, Inc.</em>, a PCI-DSS Level 1 service
            provider. <strong>FIC never sees, receives, or stores your card number or bank account number.</strong> We do
            retain your donor name, email, gift amount, designation, frequency, and Stripe transaction ID in order to
            issue tax receipts and maintain accurate records as required of a 501(c)(3) organization.
          </p>
          <p>
            <strong>Website analytics.</strong> We may collect anonymous, aggregated usage data (pages viewed, device
            type, approximate location) for the sole purpose of improving the Website. We do not use third-party
            advertising trackers.
          </p>
          <p>
            <strong>Cookies.</strong> The Website uses only the essential cookies required to keep you signed in to the
            admin panel and to remember your preferences. No advertising or cross-site tracking cookies are set.
          </p>

          <h2 className="font-serif text-2xl text-ink pt-4">2. How We Use Your Information</h2>
          <p>We use your information only to:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Communicate with you about FIC programs, events, and services you requested.</li>
            <li>Process your donation and send you an official donation receipt.</li>
            <li>Keep records required by our 501(c)(3) status and by U.S. federal and Michigan state law.</li>
            <li>Improve the Website and respond to security incidents.</li>
          </ul>
          <p>
            <strong>We do not sell, rent, or share your personal information</strong> with third parties for their
            marketing use. We share only the minimum necessary with vetted service providers:
            <em> Stripe (payment processing)</em>, <em>Resend (transactional email)</em>, and
            <em> our secure hosting provider</em>. Each of these acts only on our behalf and under written agreements.
          </p>

          <h2 className="font-serif text-2xl text-ink pt-4">3. How We Protect It</h2>
          <p>
            Data is encrypted in transit (HTTPS) and at rest where stored. Access to donor and member data is
            restricted to authorized FIC staff and board members on a need-to-know basis. Admin access requires a
            unique login and is logged for audit.
          </p>

          <h2 className="font-serif text-2xl text-ink pt-4">4. Children's Privacy</h2>
          <p>
            The Website is not directed at children under 13. We do not knowingly collect personal information from
            children under 13. Parents and guardians who have questions or concerns may contact us at the email below
            and we will promptly delete any such information.
          </p>

          <h2 className="font-serif text-2xl text-ink pt-4">5. Your Rights</h2>
          <p>
            You may request to view, correct, or delete your personal information at any time by emailing{" "}
            <a href="mailto:flintislamiccenter@gmail.com" className="text-navy underline">flintislamiccenter@gmail.com</a>.
            We will respond within a reasonable timeframe. Note that donation records are retained for tax and audit
            purposes for the period required by law.
          </p>

          <h2 className="font-serif text-2xl text-ink pt-4">6. Changes to This Policy</h2>
          <p>
            We may update this policy to reflect changes in our practices or in applicable law. Material changes will
            be posted on this page with an updated effective date.
          </p>

          <h2 className="font-serif text-2xl text-ink pt-4">7. Contact</h2>
          <p>
            Flint Islamic Center<br />
            9447 Corunna Rd, Swartz Creek, MI 48473<br />
            (810) 406-2617 ·{" "}
            <a href="mailto:flintislamiccenter@gmail.com" className="text-navy underline">flintislamiccenter@gmail.com</a>
          </p>
          <p className="text-xs text-ink/50 pt-8">Last updated: February 2026</p>
        </div>
      </div>
    </div>
  );
}
